import { socketConstants } from '../constants'

const initialState = {
  subscriptions: [],
  init: false,
  error: false,
  event: null
}

export default function socket(state = initialState, action) {
  switch (action.type) {
    case socketConstants.SOCKET_INIT:
      return {
        ...state,
        init: true
      }
    case socketConstants.SOCKET_INIT_ERROR:
      return {
        ...state,
        error: true
      }
    case socketConstants.SOCKET_SUBSCRIBE:
      return {
        ...state,
        subscriptions: state.subscriptions.concat(action.payload)
      }
    case socketConstants.SOCKET_UNSUBSCRIBE:
      return {
        ...state,
        subscriptions: state.subscriptions.filter((n) => n !== action.payload)
      }
    case socketConstants.SOCKET_EVENT:
      return {
        ...state,
        event: action.payload
      }
    default:
      return state
  }
}
